import { defineComponent as _defineComponent } from 'vue'
import {ref, onMounted} from 'vue';
import deployApi from '@/api/login';


export default /*#__PURE__*/_defineComponent({
  __name: 'database-update',
  props: ['userName', 'passWord'],
  emits: ['update'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emit = __emit;

onMounted(async () => {
	const res = await deployApi.system_init(props.userName, props.passWord);

	if (res.code === 0) {
		emit('update', true, 3, '升级部署成功');
	}
});
const loading = ref(true);

const __returned__ = { props, emit, loading }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})